import { forwardRef } from "react";
import { StyledCard } from "./Card.style.js";
import { CardProps } from "./Card.types.js";

export const Card = forwardRef<HTMLDivElement, CardProps>(({ children, cardColor = "white", ...props }, ref) => {
    const attributes = { ...props };

    return (
        <StyledCard {...attributes} cardColor={cardColor} ref={ref}>
            {children}
        </StyledCard>
    );
});
